module.exports = __webpack_public_path__ + "static/mw-7d810cc667ff615655748b53fd074137.jpg";